<kng-loader class="loader" [state]="loaderState" *ngIf="state.isLoading"></kng-loader>

<div class="main-entry" *ngIf="!state.isLoading && state.sectionTop.globalHeader[0].iconPath">
  <div class="sectionTop">
    <div class="header-content">
      <img src={{state.sectionTop.globalHeader[0].iconPath}} alt="My Toyota Icon" class="header-icon" tabindex="0">
    </div>
  </div>
  <div class="sectionMiddle">
    <div class="background"
    [ngStyle]="{
      backgroundImage: innerWidth>=767
      ? 'linear-gradient(90deg, rgba(17, 18, 18, 0.80) 46.08%, rgba(17, 18, 18, 0.00) 100.18%),url('+state.sectionMiddle.banner.bannerImageDesktopView.iconPath+')'
      : (isRaymond ? 'linear-gradient(90deg, rgba(17, 18, 18, 0.80) 46.08%, rgba(17, 18, 18, 0.00) 100.18%),url('+state.sectionMiddle.banner.bannerImageDesktopView.iconPath+')' : 'url('+state.sectionMiddle.banner.bannerImageMobileView.iconPath+')')
    }"
    >
    <div class="section-middle-container">
      <div class="text-content">
        <div class="text-overlay">
        <div>
          <h1 tabindex="0" class="content-heading">{{ state.sectionMiddle.banner.header }}</h1>
        </div>
        <div class="content-list">
          <p class="content-subText" tabindex="0" [innerHTML]="state.sectionMiddle.banner.subText| safeHtml"></p>
          <ul class="content-list-bullets">
            <ng-container *ngFor="let bullet of state.sectionMiddle.banner.bulletPoints">
              <li tabindex="0">{{ bullet.label }}</li>
            </ng-container>
          </ul>
        </div>
      </div>
      <div class="login-button" (click)="loginRegisterEvent()">
        <kng-button class="loginButton" [state]="state.sectionMiddle.banner.registerButton"></kng-button>
      </div>
    </div>
      </div>
    </div>
  </div>
  <div class="sectionBottom" *ngIf="!isRaymond">
    <div class="icons-list">
      <div class="icon">
        <img src={{state.sectionMiddle.iconsDeskTopView[0].icon.iconPath}} alt="My Fleet Icon" class="icon-image" tabindex="0" aria-label="My Fleet Icon">
        <h5 class="icon-text" tabindex="0">{{state.sectionMiddle.iconsDeskTopView[0].label}}</h5>
      </div>
      <div class="icon">
        <img src={{state.sectionMiddle.iconsDeskTopView[1].icon.iconPath}} alt="Order Management Icon" class="icon-image" tabindex="0" aria-label="Order Management Icon">
        <h5 class="icon-text" tabindex="0">{{state.sectionMiddle.iconsDeskTopView[1].label}}</h5>
      </div>
      <div class="icon">
        <img src={{state.sectionMiddle.iconsDeskTopView[2].icon.iconPath}} alt="Financing Icon" class="icon-image" tabindex="0" aria-label="Financing Icon">
        <h5 class="icon-text" tabindex="0">{{state.sectionMiddle.iconsDeskTopView[2].label}}</h5>
      </div>
      <div class="icon">
        <img src={{state.sectionMiddle.iconsDeskTopView[3].icon.iconPath}} alt="My Insights Icon" class="icon-image" tabindex="0" aria-label="My Insights Icon">
        <h5 class="icon-text" tabindex="0">{{state.sectionMiddle.iconsDeskTopView[3].label}}</h5>
      </div>
      <div class="icon">
        <img src={{state.sectionMiddle.iconsDeskTopView[4].icon.iconPath}} alt="My Toyota Store Icon" class="icon-image" tabindex="0" aria-label="My Toyota Store Icon">
        <div class="shopnow-link">
          <h5 class="icon-text" tabindex="0">{{state.sectionMiddle.iconsDeskTopView[4].label}}</h5>
          <div class="Shoplink" tabindex="0" (keypress)="navigateToShop()" (click)="navigateToShop()" role="button">
            <a href="{{state.sectionMiddle.iconsDeskTopView[4].link.url}}" target="_blank" class="shop-link" root="link">{{state.sectionMiddle.iconsDeskTopView[4].link.text}}</a>
            <img class="shoplinkicon" src="/assets/chevron _right.svg" alt="shop now icon" aria-label="shop now icon">
          </div>
        </div>
      </div>
    </div>
  </div>
  <kng-footer [state]="state.sectionBottom.footer"></kng-footer>
</div>
